import { render, staticRenderFns } from "./ContainerTag.vue?vue&type=template&id=32fa972b&"
import script from "./ContainerTag.vue?vue&type=script&lang=js&"
export * from "./ContainerTag.vue?vue&type=script&lang=js&"
import style0 from "./ContainerTag.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports